import { FC, memo, useMemo } from 'react'
import { useTopupSubscription } from '../../../providers/SubscriptionProvider'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import { currencyFormatter } from '../../../../formatters/currencyFormatter'
import pricingCalculator from '../../../../calculators/pricingCalculator'

const AdditionalTopupCard: FC = () => {
  const {
    onHandleSubmitTopup,
    availableTopupCredits,
    creditsPurchasedThisMonth,
    topupDisabled,
    topupSubmitting,
  } = useTopupSubscription()
  const { amountToPay } = useMemo(() => {
    return pricingCalculator.calculateCreditsBreakdownForPurchase({
      numberOfCreditsToBuy: availableTopupCredits,
      alreadyPurchasedThisMonth: creditsPurchasedThisMonth ?? 0,
    })
  }, [availableTopupCredits, creditsPurchasedThisMonth])
  return (
    <Box
      sx={{
        marginBottom: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Card variant="outlined">
        <CardContent>
          <Typography
            gutterBottom
            sx={{ color: 'text.secondary', fontSize: 14, textAlign: 'right' }}
          >
            Top up
          </Typography>
          <Typography variant="h6" component="div" gutterBottom>
            You have increased your monthly credit limit
          </Typography>
          <Typography variant="body2">
            Would you like to top up an additional {availableTopupCredits} credit(s) for{' '}
            {currencyFormatter.formatPenceToGBPAmountString(amountToPay)}? This will bring your
            monthly total in line with your new credit limit.
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            size="small"
            variant="outlined"
            onClick={onHandleSubmitTopup}
            disabled={topupDisabled}
            loading={topupSubmitting}
            loadingPosition="end"
          >
            top up for £{availableTopupCredits * 3}
          </Button>
        </CardActions>
      </Card>
    </Box>
  )
}

export default memo(AdditionalTopupCard)
